import React, { useEffect, useState } from 'react';

const PlayListThumbnail = ({ src, name = 'john doe', ...props }) => {
  const [thumbURl, setThubUrl] = useState(null);

  function generateThumbnail(name, size = 100, bgColor = '#40189D', textColor = '#FFFFFF') {
    // Create a canvas element
    const canvas = document.createElement('canvas');
    canvas.width = size;
    canvas.height = size;

    // Get the 2D rendering context
    const ctx = canvas.getContext('2d');

    // Set background color
    ctx.fillStyle = bgColor;
    ctx.fillRect(0, 0, size, size);

    // Set text properties
    ctx.font = `${size / 2}px Arial`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillStyle = textColor;

    // Get the first letter (or character) of the name
    const firstLetter = name.charAt(0).toUpperCase();

    // Calculate text position
    const x = size / 2;
    const y = size / 2;

    // Draw the first letter on the canvas
    ctx.fillText(firstLetter, x, y);

    // Convert the canvas to an image URL
    const thumbnailUrl = canvas.toDataURL();

    return thumbnailUrl;
  }

  useEffect(() => {
    if (!src) {
      const thumbnailUrl = generateThumbnail(name);
      setThubUrl(thumbnailUrl);
    }
  }, [src, name]);

  return <img {...props} src={src ? `${process.env.REACT_APP_MEDIA_URL}/${src}` : thumbURl} alt="Playlist" width={60} height={60} />;
};

export default PlayListThumbnail;

